enum FormsExtractionDialogFields {
	FORMAT = "format"
}

export default FormsExtractionDialogFields;